import ReactiveWidget from "lib/reactiveWidget";

import $              from "jquery"
import select2        from "select2"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"

import moment from 'moment'
import 'moment-timezone'
import 'moment-timezone/builds/moment-timezone-with-data-2012-2022.min.js'
import fetchGroups from "servos/fetchGroupData";
import fetchVehicles from "servos/fetchVehicleData";
import applyLocalTimeZone from "servos/applyLocalTimeZone";

class CreateTenderWidget extends ReactiveWidget  {
  bind() {
    this.form = this.root.find('form')
    this.form.find('.loading-spinner').hide()
    stopSpinner.call(this)
    bindFormActions.call(this)

    // Fetch the data
    resetPage.call(this)
    fetchVehicles.call(this, '#new', this.form.serializeArray())
  }

  render() {
  }
}

var bindFormActions = function() {
  this.root.on('keyup', '.search-query', (e) => {
    delay(() => {
      resetPage.call(this)
      fetchVehicles.call(this, '#new', this.form.serializeArray())
    }, 300 );
  })

  // Select 2
  let select2_elem = this.form.find(".filter-select2")
  $(select2_elem).select2({
    placeholder: 'Select',
    allowClear: true,
    theme: "bootstrap"
  }).on('change', (e) => {
    resetPage.call(this)
  })

  // Select 3
  let select3_elem = this.form.find(".filter-select3")
  $(select3_elem).select2({
    placeholder: 'Select',
    allowClear: true,
    theme: "bootstrap"
  })

  // Pagination
  // let pagination_links = this.root.find('.pagination a')/
  this.root.on('click', '.pagination a', (e) => {
    e.preventDefault()
    e.stopPropagation()

    let url   = $(e.target).attr('href')
    this.form.find("input[name='page']").val(window.getSearchParams(url, 'page') || "0")
    fetchVehicles.call(this, '#new', this.form.serializeArray())
  })

  // Capture Country Select
  let country_select = this.form.find(".sort-by-country")
  $(country_select).select2({
    placeholder: 'Select',
    allowClear: true,
    theme: "bootstrap"
  }).on('change', (e) => {
    applyLocalTimeZone.call(this)
    fetchGroups.call(this, this.form.serializeArray())
    fetchVehicles.call(this, '#new', this.form.serializeArray())
    resetPage.call(this)

    // default end time 5 days after the start time
    $("#tender_start_time").on("dp.change", function(e) {
      let startTime = e.currentTarget.value;
      let endTime = moment(startTime, 'YYYY/MM/DD hh:mm A z')
      endTime.add(5, 'days')
      $('#tender_end_time').data("DateTimePicker").date(endTime)
    })
  })

  // Capture Form Submit
  this.form.on('submit', (e) => {
    e.preventDefault();
    fetchVehicles.call(this, '#new', this.form.serializeArray())
    return false
  })
}

var resetPage = function() {
  this.form.find("input[name='page']").val('0')
}

var startSpinner = function() {
  this.form.find('.loading-spinner').fadeIn(400)
}

var stopSpinner = function() {
  this.form.find('.loading-spinner').fadeOut(400)
}

export default CreateTenderWidget
